import { NgPackageData } from './ng-package-data';

export class PackageSearchResult {
  public rootPackage: NgPackageData;
  public secondaryPackages: NgPackageData[];
}
